import { render, staticRenderFns } from "./ExclusiveProducts.vue?vue&type=template&id=7bf26767"
import script from "./ExclusiveProducts.vue?vue&type=script&lang=js"
export * from "./ExclusiveProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports